import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { LandingRouteService } from '@core/services/landing-route.service';
import { from, map, Observable, of, switchMap } from 'rxjs';

/**
 * For login / register / password-recovery: signed-in users never stay here.
 * LandingRouteService picks the final destination in one step.
 */
export const guestGuard: CanActivateFn = ():
  | boolean
  | UrlTree
  | Observable<boolean | UrlTree> => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const landing = inject(LandingRouteService);

  auth.purgeLegacyDemoStorage();

  if (!auth.hasToken()) {
    return true;
  }

  const resolve = (
    user: ReturnType<AuthService['currentUser']>,
  ): Observable<boolean | UrlTree> => {
    if (!user) return of(true);
    return from(landing.resolve(user)).pipe(map((url) => router.parseUrl(url)));
  };

  const existing = auth.currentUser();
  if (existing) return resolve(existing);

  return auth.ensureSession().pipe(switchMap(resolve));
};
